interface Props {
  fill?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
}

const GotQuestion = ({
  fill = '#757575',
  width = 25,
  height = 25,
  className = 'GotQuestion',
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25.846 25.846"
    height={height}
    width={width}
    className={className}
  >
    <path
      d="M12.923,0A12.923,12.923,0,1,0,25.846,12.923,12.937,12.937,0,0,0,12.923,0Zm0,24.852A11.929,11.929,0,1,1,24.852,12.923,11.943,11.943,0,0,1,12.923,24.852Z"
      fill={fill}
    />
    <path
      d="M25.5,37a.5.5,0,0,0-.5.5v.994a.5.5,0,0,0,.994,0V37.5A.5.5,0,0,0,25.5,37Z"
      transform="translate(-12.574 -18.61)"
      fill={fill}
    />
    <path
      d="M22.032,9h-.057A3.977,3.977,0,0,0,18,12.976a.5.5,0,1,0,.994,0,2.982,2.982,0,0,1,3.025-2.982,3.039,3.039,0,0,1,2.939,2.939,2.969,2.969,0,0,1-1.367,2.551,4.741,4.741,0,0,0-2.111,4.032v1.413a.5.5,0,1,0,.994,0V19.516a3.8,3.8,0,0,1,1.656-3.2,3.957,3.957,0,0,0,1.823-3.4A4,4,0,0,0,22.032,9Z"
      transform="translate(-9.053 -4.527)"
      fill={fill}
    />
  </svg>
);

export default GotQuestion;
